import AbstractRepository from "@/repositories/AbstractRepository";

export interface CarouselItem {
    uuid?: string;
    title: string;
    imageUrl?: string;
    active?: string;
    link?: string;
    icon?: string;
    owner?: {
        uuid: string;
    };
}
export default class CarouselItemRepository extends AbstractRepository {
    protected static resource: string = "carouselitem";

    protected static defaultFields: string[] = [
        "uuid",
        "title",
        "link",
        "imageUrl",
        "owner.uuid",
        "active",
        "icon",
    ];
}
